import React from 'react';
import ErrorPageTemplate from './ErrorPageTemplate';
import BoBroken from 'app/ui/bo/BoBroken';

export default function SystemError() {
  return (
    <ErrorPageTemplate
      disableLogoLink
      bo={BoBroken}
      messageIds={[
        'common.errorPages.systemError1',
        'common.errorPages.systemError2',
      ]}
    />
  );
}



// WEBPACK FOOTER //
// ./src/app/ui/pages/error/SystemError.js